__turbopack_context__.v({
  "button": "AddDegreeButton-module__rwOAVq__button",
});
